import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/achievementAwardResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={8}>
                <DTextField
                    // name={resource.fields.description.name}
                    label={resource.fields.description.label}
                    required={resource.fields.description.required}
                    options={resource.fields.description.options ?? []}
                    error={!!errors?.description}
                    {...register(resource.fields.description.name)}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.awardDate.label}
                    required={resource.fields.awardDate.required}
                    {...register(resource.fields.awardDate.name)}
                    error={!!errors.awardDate}
                    helperText={errors?.awardDate?.message}
                    type={resource?.fields?.awardDate?.type}
                />
            </GridItem>

            <GridItem xs={12} md={12}>
                <DTextField
                    label={resource.fields.awardedBy.label}
                    {...register(resource.fields.awardedBy.name)}
                    error={!!errors?.awardedBy}
                    helperText={errors?.awardedBy?.message}
                />
            </GridItem>
        </GridContainer>
    );
}
